/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LTR
 */
export interface LTR {
    /**
     * 
     * @type {string}
     * @memberof LTR
     */
    unit?: string;
    /**
     * 
     * @type {number}
     * @memberof LTR
     */
    remaining?: number;
    /**
     * 
     * @type {number}
     * @memberof LTR
     */
    total?: number;
}

/**
 * Check if a given object implements the LTR interface.
 */
export function instanceOfLTR(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function LTRFromJSON(json: any): LTR {
    return LTRFromJSONTyped(json, false);
}

export function LTRFromJSONTyped(json: any, ignoreDiscriminator: boolean): LTR {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'unit': !exists(json, 'unit') ? undefined : json['unit'],
        'remaining': !exists(json, 'remaining') ? undefined : json['remaining'],
        'total': !exists(json, 'total') ? undefined : json['total'],
    };
}

export function LTRToJSON(value?: LTR | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'unit': value.unit,
        'remaining': value.remaining,
        'total': value.total,
    };
}

